import { render, staticRenderFns } from "./new_class.vue?vue&type=template&id=944b4cb2&scoped=true"
import script from "./new_class.vue?vue&type=script&lang=ts"
export * from "./new_class.vue?vue&type=script&lang=ts"
import style0 from "./new_class.vue?vue&type=style&index=0&id=944b4cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944b4cb2",
  null
  
)

export default component.exports